import 'babel-polyfill'

import React, { useState } from 'react'
import { ThemeProvider } from 'emotion-theming'
import { ApolloProvider } from 'react-apollo'
import client from './apollo/client'
import theme, { GlobalStyle } from './theme.style'
import createStore from './store'
import { Provider } from 'react-redux'
import { FormRenderProvider } from 'react-form-helper'
import { renderInput } from './components/generic/form'
import { ChatProvider } from './context'              
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import FuneralQuickQuote from './components/funeral/FuneralQuickQuote'
import firebase from "firebase/app";
import 'firebase/performance';
import 'firebase/analytics';
import 'firebase/messaging';
import * as Sentry from "@sentry/react";
import ClearanceCertificateQuickQuote from './components/clearanceCertificate/ClearanceCertificateQuickQuote/ClearanceCertificateQuickQuote'
import CreditLifeQuickQuote from './components/insurance/CreditLifeQuickQuote/CreditLifeQuickQuote'

Sentry.init({
  dsn: process.env.QQ_MODAL_SENTRY_DSN
});

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.FIREBASE_DATABASE_URL,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID,
    measurementId: process.env.FIREBASE_MEASUREMENT_ID
  });
}

firebase.analytics();
firebase.performance();

const store = createStore()
global.QQ = {}

function QQModalWrapper() {
  const [funeralQuickQuoteOpen, setFuneralQuickQuoteOpen] = useState(false)
  const [clearanceCertificateQuickQuoteOpen, setClearanceCertificateQuickQuoteOpen] = useState(false)
  const [creditLifeQuickQuoteOpen, setCreditLifeQuickQuoteOpen] = useState(false)

  global.QQ.open = setFuneralQuickQuoteOpen
  global.QQ.ccOpen = setClearanceCertificateQuickQuoteOpen
  global.QQ.cliOpen = setCreditLifeQuickQuoteOpen

  return <Sentry.ErrorBoundary fallback={"An error has occurred"}>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Provider store={store}>
          <FormRenderProvider renderInput={renderInput}>
            <ApolloProvider client={client}>
              <ChatProvider>      
                <FuneralQuickQuote open={funeralQuickQuoteOpen} setOpen={setFuneralQuickQuoteOpen} />
                <ClearanceCertificateQuickQuote open={clearanceCertificateQuickQuoteOpen} setOpen={setClearanceCertificateQuickQuoteOpen} />
                <CreditLifeQuickQuote open={creditLifeQuickQuoteOpen} setOpen={setCreditLifeQuickQuoteOpen} />
              </ChatProvider>
            </ApolloProvider> 
          </FormRenderProvider>
        </Provider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  </Sentry.ErrorBoundary>
}

export default QQModalWrapper
